import React, {useEffect, useState} from 'react';
import question from "./../../images/question.svg"
import {Link} from "react-router-dom";
export default function Permissions(props) {
    return (

                         <div className="row justify-content-between permissions">
                             <div className="col-7 left">
                                 <h6 style={{textAlign:'left'}}>Check Your Permissions</h6>
                                 <p>Hey! Before you start this process, Please make sure you have these permissions! By proceeding this step we will help you to easily upload your event logs file.</p>
                             </div>
                             <div className="col-5 right">
                                 <ul>
                                     <li>Content Goes Here</li>
                                     <li>Content Goes Here</li>
                                     <li>Content Goes Here</li>
                                     <li>Content Goes Here</li>
                                 </ul>
                             </div>
                             <header className="col-12">
                                 <div className="d-flex mt-32">
                                     <img src={question} alt="question"/>
                                     <p>You don't have them?</p>
                                 </div>
                                 <div className="d-flex justify-content-end mt-40">
                                     <div onClick={props.next} className="btn">Proceed</div>
                                 </div>
                             </header>
                         </div>

    );
}
